module.exports = __webpack_public_path__ + "static/ambasador_ania_gulko-dfb222b7f36f99a867d3252f4ebf8c88.png";